module.exports = __webpack_public_path__ + "static/media/machine_learning.b9495035.jpg";